import styled from 'styled-components';
import { colors } from '../../constants';

const getFontSize = variant => {
  switch (variant) {
    case 'body':
      return '16px';
    case 'title2':
      return '24px';
    case 'body-bold':
      return '16px';
    case 'title3':
      return '24px';
    case 'caption':
      return '12px';
    case 'body-small':
      return '14px';
    default:
      return '16px';
  }
};

const getLineHeight = variant => {
  switch (variant) {
    case 'body':
      return '24px';
    case 'title2':
      return '32px';
    case 'body-bold':
      return '24px';
    case 'title3':
      return '40px';
    case 'caption':
      return '16px';
    case 'body-small':
      return '16px';
    default:
      return '16px';
  }
};

const getFontWeight = variant => {
  switch (variant) {
    case 'body':
      return 400;
    case 'title2':
      return 600;
    case 'body-bold':
      return 600;
    case 'title3':
      return 600;
    case 'caption':
      return 400;
    case 'body-small':
      return 400;
    default:
      return 400;
  }
};

const Text = styled.div`
  font-family: 'Rubik', sans-serif;
  color: ${props => props.color || colors.navy};
  font-size: ${props => getFontSize(props.variant)};
  line-height: ${props => getLineHeight(props.variant)};
  font-weight: ${props => getFontWeight(props.variant)};
  display: flex;
  align-items: center;
`;

export default Text;
